import '../../../../../../Avency.Sprehe.Base/Resources/Private/Assets/JavaScript/Project/globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        $('.modal').on('show.bs.modal', function (event) {
            if (window.lazyLoadObject instanceof window.LazyLoad) {
                window.lazyLoadObject.update();
            }
        });
    });

    // Open the modal of the brand filter by click, because it did not always open automatically.
    $('.brandFilter__brands--overlay').on('click', function (event) {
        event.preventDefault();

        var targetId = $(this).parents('.brandFilter__brands ').data('target');
        $(targetId).modal('show');
    });
})(jQuery, window, document, window.PageLoadedQueue);
